<template>
  <section class="closefriend-hero h-100">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>


    <customer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></customer-menu>
    <header-menu @slideMenu="slideBar()"></header-menu>
    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header -->
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
            <div>
              <h5 class="text-white font-weight-700 mb-0 font-size-20">Custom Requests</h5>
              <span class="text-muted font-size-12">Request personalized perks & custom services</span>
            </div>
          </div>
          
          <div class="login-card mx-auto mb-4 p-3 p-md-4 mt-2">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
              <h6 class="text-white font-weight-600 mb-0 font-size-16">Send a Custom Request</h6>
            </div>
            
            <div class="d-flex flex-row overflow-auto py-2 horizontal-scroll-container" style="gap: 16px;">
              <custom-request-influencer-avatar 
                v-for="(influencer, index) in influencers" 
                :key="index"
                :influencer="influencer" 
                @customRequest="submitCustomRequest(influencer)" 
                class="flex-shrink-0" />
            </div>
            <div v-if="influencers.length === 0" class="text-center py-4">
              <p class="text-muted font-size-14 mb-0">You are not following any creators yet.</p>
            </div>
          </div>

          <div class="login-card mx-auto mb-4 p-3 p-md-4">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
              <h6 class="text-white font-weight-500 mb-0">Pending Requests</h6>
            </div>
            <global-message></global-message>
            
            <!-- Loading Skeleton State -->
            <div v-if="isLoading" class="row mt-2">
              <div class="col-12 col-md-6 col-lg-4 mb-4" v-for="i in 2" :key="i">
                <div class="custom-card-transparent p-4 d-flex flex-column justify-content-between" style="min-height: 180px; animation: pulse 1.5s infinite;">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div style="width: 40px; height: 16px; background: rgba(255,255,255,0.08); border-radius: 4px;"></div>
                    <div style="width: 55px; height: 22px; background: rgba(255,255,255,0.08); border-radius: 4px;"></div>
                  </div>
                  <div style="height: 18px; width: 65%; background: rgba(255,255,255,0.08); border-radius: 4px; margin-bottom: 12px;"></div>
                  <div style="height: 14px; width: 90%; background: rgba(255,255,255,0.04); border-radius: 4px;"></div>
                  <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top border-white-10">
                    <div style="height: 14px; width: 30%; background: rgba(255,255,255,0.06); border-radius: 4px;"></div>
                    <div style="height: 14px; width: 25%; background: rgba(255,255,255,0.06); border-radius: 4px;"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div v-else-if="customRequests.length === 0" class="text-center py-5">
              <div class="stella-empty-state-icon mb-3">
                <i class="fa fa-envelope-open-o font-size-22" style="opacity: 0.4; color: #E53BB9;"></i>
              </div>
              <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">No pending requests</h5>
              <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">
                Your custom requests will appear here.
              </p>
            </div>
            
            <div v-else class="row mt-2">
              <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="(customRequest, index) in customRequests" :key="index">
                <div class="custom-card-transparent h-100 d-flex flex-column cursor-pointer" @click="statusAction(customRequest)" data-toggle="popover" data-placement="top" data-trigger="hover" :data-content="desc(customRequest)">
                  <div class="stella-card-header d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                      <span class="stella-card-index">#{{ index + 1 }}</span>
                      <span class="font-size-11" style="color: rgba(255, 255, 255, 0.35);">• {{ customRequest.updatedAt | formatDateTime }}</span>
                    </div>
                    <span class="stella-card-price">${{ customRequest.counterOfferPrice ? customRequest.counterOfferPrice : customRequest.offerPrice }}</span>
                  </div>
                  <div class="stella-card-body flex-grow-1">
                    <h6 class="stella-card-title">{{ customRequest.influencer.name }}</h6>
                    <p class="stella-card-desc mt-2 mb-0">{{ desc(customRequest) }}</p>
                  </div>
                  <div class="stella-card-footer d-flex align-items-center justify-content-between mt-auto">
                    <span class="stella-card-status" :style="'color: ' + getStatusColorHex(customRequest.status) + '; font-weight: 500;'">
                      <span class="status-dot" :style="'background-color: ' + getStatusColorHex(customRequest.status)"></span> 
                      {{ getStatus(customRequest.status) }}
                    </span>
                    <span class="stella-card-action d-inline-flex align-items-center text-danger font-weight-600" v-if="customRequest.status === CR_STATUS_REVIEW" @click.stop="confirmDeleteCustomRequest(customRequest.id)">
                      <i class="fa fa-trash me-1 font-size-11"></i> Delete
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

          <model-customer-custom-request-submit
            ref="customRequestConfirm"
            @savedCustomRequest="(customRequest) => {
            loadCustomRequest();
            $refs.customRequestDone.show(customRequest);
         }"
            @submittedCustomRequestOption="(customRequest) => {
            $refs.customRequestOption.show(customRequest, user.id);
          }"/>

          <model-customer-custom-request-option-info
            ref="customRequestOption"
            @savedCustomRequestOption="(customRequest) => {
            loadCustomRequest();
            if(customRequest.status === CR_STATUS_ACCEPTED){
               $refs.customRequestAccepted.show(customRequest);
            } else if(customRequest.status === CR_STATUS_READY) {
               $refs.customRequestDone.show(customRequest, true);
            }
          }"
            @back="() => {
             $refs.customRequestConfirm.simpleShow();
          }"
          />

          <model-customer-custom-request-done
            ref="customRequestDone" @doneCustomRequest="() => {
            // loadCustomRequest();
          }"/>


          <model-customer-custom-request-counter-offer
            ref="customRequestCounterOffer"
            @accepted="loadCustomRequest()"
            @counterOffer="(customRequest) => {
             $refs.counterOfferSubmit.show(customRequest);
          }"/>
          <model-customer-custom-request-accepted 
            ref="customRequestAccepted"
            @savedCustomRequest="(customRequest) => {
              loadCustomRequest();
              $refs.customRequestDone.show(customRequest, true);
            }"/>

          <!-- Counter offer start   -->
          <model-customer-custom-request-counter-offer-submit
            :type="CR_TYPE_CUSTOMER"
            ref="counterOfferSubmit" @counterOfferSubmitted="() => {
            loadCustomRequest();
            $refs.counterOfferComplete.show();
          }
        "/>
          <model-customer-custom-request-counter-offer-complete
            :type="CR_TYPE_CUSTOMER"
            ref="counterOfferComplete"/>
          <!-- Counter offer end   -->

          <model-delete ref="deleteCustomRequest" @delete="deleteCustomRequest()"/>

          <model-image-view ref="imageView"/>
          <model-video-view ref="videoView"/>
          <model-link ref="linkView"/>
  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import {SERVICE_CONTENT, SERVICE_IDENTIY, SERVICE_SUBSCRIPTION, SERVICE_PAYMENT} from "@/properties/micro-service";
import CustomerMenu from "@/components/module/customer/shared/CustomerMenu";
import CustomRequestInfluencerAvatar from "@/components/module/customer/custom-request/CustomRequestInfluencerAvatar";
import CustomerPwaActionBar from "@/components/module/customer/shared/CustomerPwaActionBar";
import ModelCustomerCustomRequestConfirm
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestConfirm";
import ModelCustomerCustomRequestDone from "@/components/module/customer/custom-request/ModelCustomerCustomRequestDone";
import ModelCustomerCustomRequestSubmit
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestSubmit";
import {
  CR_STATUS_ACCEPTED,
  CR_STATUS_ACTION,
  CR_STATUS_COLOR,
  CR_STATUS_COMPLETED,
  CR_STATUS_COUNTER,
  CR_STATUS_CUSTOMER_COUNTER,
  CR_STATUS_EXPIRED,
  CR_STATUS_PENDING,
  CR_STATUS_READY,
  CR_STATUS_RESUBMIT,
  CR_STATUS_REVIEW,
  CR_TYPE_CUSTOMER
} from "@/properties/custom-request-status";
import ModelDelete from "@/components/module/influencer/content/ModelDelete";
import ModelCustomerCustomRequestCounterOffer
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestCounterOffer";
import ModelCustomerCustomRequestAccepted
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestAccepted";
import ModelCustomerCustomRequestCounterOfferSubmit
  from "@/components/module/shared/custom-request/ModelCustomRequestCounterOfferSubmit";
import ModelCustomerCustomRequestCounterOfferComplete
  from "@/components/module/shared/custom-request/ModelCustomRequestCounterOfferComplete";
import ModelImageView from "@/components/module/shared/ModelImageView";
import ModelVideoView from "@/components/module/shared/ModelVideoView";
import {
  CONTENT_TYPE_APPLICATION,
  CONTENT_TYPE_IMAGE,
  CONTENT_TYPE_URL,
  CONTENT_TYPE_VIDEO
} from "@/properties/content-type";
import ModelLink from "@/components/module/customer/custom-request/ModelLink";
import {geDecodedToken, getTokenExp, isRole, isTokenExpired} from "@/common/http-common";
import {ACCESS_TOKEN} from "@/properties/close-friend";
import ModelCustomerCustomRequestOptionInfo
  from "@/components/module/customer/custom-request/ModelCustomerCustomRequestOptionInfo";
import {customRequestDesc, isUserActive} from "@/common/comm-service";
import titleMixin from "../../../../mixin/title-mixin";
import {CUSTOM_REQUEST, paymentCancelled, paymentOtherStatus, paymentPaid} from "@/common/analytics-service";

export default {
  name: 'CustomerCustomRequestList',
  title: 'Customer custom requests',
  mixins: [httpMixin, newSubscriptionMixin, titleMixin],
  props: ['query'],
  components: {
    HeaderMenu, CustomerMenu,
    GlobalMessage, CustomRequestInfluencerAvatar,
    CustomerPwaActionBar,
    ModelCustomerCustomRequestConfirm,
    ModelCustomerCustomRequestDone,
    ModelCustomerCustomRequestSubmit,
    ModelCustomerCustomRequestCounterOffer,
    ModelCustomerCustomRequestAccepted,
    ModelCustomerCustomRequestOptionInfo,
    ModelImageView, ModelVideoView,
    ModelDelete, ModelLink,
    ModelCustomerCustomRequestCounterOfferSubmit,
    ModelCustomerCustomRequestCounterOfferComplete
  },
  data() {
    return {
      isLoading: true,
      influencers: [],
      customRequests: [],
      showSlideBar: false,
      deleteCustomRequestId: null,

      pageNumber: 0,
      noOfItems: 999,
      CR_STATUS_COLOR,
      CR_STATUS_REVIEW,
      CR_TYPE_CUSTOMER,

      CR_STATUS_ACCEPTED,
      CR_STATUS_READY

    }
  },
  created() {

    //Payment status when redirected by stripe after making payment for custom request
    if (this.$route.query.status) {
      if (this.$route.query.status === 'success') {
        paymentPaid(this, CUSTOM_REQUEST, this.getPayInfluencer());
        this.setMessage('PAYMENT.SUCCESSFUL');
        if (this.$route.query.clientReferenceId) {
          let clientReferenceId = this.$route.query.clientReferenceId;
          let URL = `${SERVICE_PAYMENT}/api/v1/stripe/transactions/${clientReferenceId}`;
          //location.reload();
          this.putData(URL, {}, (data) => {
            this.loadCustomRequest();          
          }, (error) => {
            this.setMessage(this.$route.query.status);
          });
        }
      } else if (this.$route.query.status === 'cancelled') {
        paymentCancelled(this, CUSTOM_REQUEST, this.getPayInfluencer());
        this.setMessage('PAYMENT.CANCELLED');
      } else if (this.$route.query.status === 'failure') {
        this.setMessage('PAYMENT.FAILED');
      } else {
        paymentOtherStatus(this, this.$route.query.status, CUSTOM_REQUEST, this.getPayInfluencer());
        this.setMessage(this.$route.query.status);
      }
      const currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.replaceState({ path: currentUrl }, '', currentUrl);
    }

    this.setRedirectedFrom(null);
    if (this.$route.params.urlPrefix) {
      this.checkTokenValidity(() => {
        let tokenExp = getTokenExp(ACCESS_TOKEN);
        if (tokenExp && !isTokenExpired(ACCESS_TOKEN) && !isRole('INFLUENCER')) {
          this.onCreate();
        } else {
          this.redirectedByInfluencerSuffix();
        }
      }, true);
    } else {
      this.onCreate();
    }

  },
  methods: {
    ...mapGetters(['getUser', 'getPayInfluencer']),
    ...mapActions(['setUser', 'setRedirectedFrom', 'setMessage', 'setPayInfluencer']),
    isUserActive,
    onCreate() {

      let urlPrefix = this.$route.params.urlPrefix;
      if (!this.getUser()) {
        let customerId = geDecodedToken(ACCESS_TOKEN).id;
        let url = `${SERVICE_IDENTIY}/api/v1/customers/${customerId}`;
        this.getData(url, (customer) => {
          this.setUser(customer);
          this.initLoad(urlPrefix);
        });
      } else {
        this.initLoad(urlPrefix);
      }
    },
    redirectedByInfluencerSuffix() {
      let invitee = this.$route.params.urlPrefix;
      this.getUnSecureData(`${SERVICE_IDENTIY}/api/v1/influencers/urlSuffix/${invitee}`, (data) => {
        if (!isUserActive(data)) {
          this.$router.replace({name: 'DisabledAccount'});
        } else {
          this.setRedirectedFrom(this.$route.path);
          this.$router.replace({
            name: 'LoginMobile',
            params: {urlPrefix: invitee}
          });
        }
      });
    },
    initLoad(urlPrefix) {
      this.user = this.getUser();
      //api/v1/customers/{customerId}/subscriptions/
      let url = `${SERVICE_SUBSCRIPTION}/api/v1/customers/${this.user.id}/subscriptions/influencers`;
      this.getData(url, (influencers) => {
        this.influencers = influencers;
        if (urlPrefix && influencers.length > 0) {
          let influencer = influencers.find((inf) => inf.urlSuffix === urlPrefix);
          if (influencer) {
            this.submitCustomRequest(influencer);
          }
        }
      })
      this.loadCustomRequest();
    },
    desc: customRequestDesc,
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    upperCaseFirstLetter(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
    loadCustomRequest() {
      this.isLoading = true;
      console.log('HERE...loadCustomRequest');
      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/custom-request/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`;
      this.getData(url, (page) => {
        this.customRequests.splice(0);
        this.customRequests.push(...page.content);
        this.$nextTick(() => {
          $('[data-toggle="popover"]').popover();
        });
      })
    },
    submitCustomRequest(influencer) {
      if (isUserActive(influencer)) {
        this.$refs.customRequestConfirm.show(influencer.id, this.user.id, influencer.customRequestMinPrice);
      }
    },
    confirmDeleteCustomRequest(id) {
      this.deleteCustomRequestId = id;
      this.$refs.deleteCustomRequest.show();
    },
    deleteCustomRequest() {
      this.$refs.deleteCustomRequest.hide();
      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.user.id}/custom-request/${this.deleteCustomRequestId}`;
      this.getDelete(url, (date) => {
        this.setMessage('DELETED.SUCCESSFULLY');
        this.loadCustomRequest();
      });
    },
    statusAction(customRequest) {
      if (customRequest.status === CR_STATUS_COUNTER) {
        this.$refs.customRequestCounterOffer.show(customRequest);
      } else if (customRequest.status === CR_STATUS_ACCEPTED) {
        this.$refs.customRequestAccepted.show(customRequest);
      } else if (customRequest.status === CR_STATUS_COMPLETED) {
        let content = customRequest.content;

        if (content.type === CONTENT_TYPE_IMAGE && content.cdnUrl) {
          this.$refs.imageView.show(content.cdnUrl);
        } else if (content.type === CONTENT_TYPE_VIDEO && content.cdnUrl) {
          this.$refs.videoView.show(content.cdnUrl);
        } else if (content.type === CONTENT_TYPE_URL || content.type === CONTENT_TYPE_APPLICATION) {
          this.$refs.linkView.show(content);
        }
      } else if (customRequest.status === CR_STATUS_EXPIRED) {
        this.$refs.customRequestConfirm.resubmitShow(customRequest);
      }
    },
    getStatus(status) {
      if (status === CR_STATUS_COUNTER || status === CR_STATUS_ACCEPTED) {
        return CR_STATUS_ACTION;
      } else if (status === CR_STATUS_READY || status === CR_STATUS_CUSTOMER_COUNTER) {
        return CR_STATUS_PENDING;
      } else if (status === CR_STATUS_EXPIRED) {
        return CR_STATUS_RESUBMIT;
      } else {
        return status;
      }
    },
    getStatusColorHex(status) {
      const s = status === CR_STATUS_ACTION ? CR_STATUS_REVIEW : status;
      if (s === 'Review' || s === CR_STATUS_REVIEW || s === 'Counter' || s === 'CustomerCounter') return '#F1C40F'; // Warning (Amber)
      if (s === 'Ready' || s === 'Completed' || s === CR_STATUS_READY) return '#55EFC4'; // Success (Emerald)
      if (s === 'Pending' || s === CR_STATUS_PENDING) return '#80CBFE'; // Info (Blue)
      if (s === 'Declined' || s === 'Canceled' || s === 'Expired') return '#FF4B81'; // Danger (Red)
      return '#B8B8B8'; // Default (Gray)
    }
  }
};
</script>

<style scoped>
.msg-inbox-row {
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s ease;
}
.msg-inbox-row:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.horizontal-scroll-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.horizontal-scroll-container::-webkit-scrollbar {
  height: 6px;
}
.horizontal-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}
.horizontal-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}
.horizontal-scroll-container::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.3);
}



.stella-card-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stella-card-header {
  margin-bottom: 12px;
}
.stella-card-index {
  color: rgba(255,255,255,0.4);
  font-size: 12px;
  font-weight: 600;
}
.stella-card-price {
  background: linear-gradient(135deg, #ff6ec7, #f9a826);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  font-size: 14px;
  padding: 4px 10px;
  background-color: rgba(255,255,255,0.05);
  border-radius: 20px;
}
.stella-card-title {
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 0;
  text-transform: capitalize;
}
.stella-card-footer {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(255,255,255,0.05);
}
.stella-card-status {
  font-size: 12px;
  display: flex;
  align-items: center;
}
.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  display: inline-block;
}
.stella-card-action {
  font-size: 11px;
  color: #fff;
  opacity: 0.8;
  font-weight: 500;
}

@media only screen and (max-width: 768px) {
  .submit-subscribe-button
  {
    padding: 8px 0px;
  }

}
</style>

